/**
 * Initiates the Instagram OAuth flow
 * @returns {void} Redirects to Instagram OAuth page
 */
export const initiateInstagramOAuth = () => {
  const params = new URLSearchParams({
    client_id: process.env.INSTAGRAM_APP_ID,
    redirect_uri: `${process.env.BASE_URL}/connect/instagram`,
    scope: 'instagram_business_basic,instagram_business_content_publish,instagram_business_manage_insights',
    response_type: 'code',
    state: Math.random().toString(36).substring(7),
    auth_type: 'reauthenticate',
    force_authentication: 'true'
  });
  window.location.href = `https://www.instagram.com/oauth/authorize?${params.toString()}`;
}; 